import { getParam } from './getParam';
import { getSetIdFromUrl } from './getSetIdFromUrl';
import { RegistrationFormType, WidgetConfig, WidgetType } from '../interface';
import { UngatedSessionType } from '../../../GraphQL/schema/types';

export const getWidgetUrl = ({
  shortUrl,
  url,
  formType,
  type,
  embeddedPlayer,
}: WidgetConfig): string => {
  if (type === WidgetType.EmbeddedPlayer) {
    const mode = embeddedPlayer?.sessionType === UngatedSessionType.Replay ? 'replay' : 'on-demand';
    return `${shortUrl}/embedded/${mode}`;
  }
  let useFastForm = formType === RegistrationFormType.FastRendering;
  if (getParam('ewuff') === '1') {
    useFastForm = true;
  }
  if (getParam('ewulf') === '1') {
    useFastForm = false;
  }
  const formPath = useFastForm ? 'register/fast-form/' : 'register/widget/';
  if (shortUrl) {
    return `${shortUrl}/${formPath}`;
  }
  const setId = getSetIdFromUrl(url);
  const widgetUrl = new URL(url);
  return `${widgetUrl.origin}/webinar/${setId}/${formPath}`;
};
